import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { Field, reduxForm } from 'redux-form';
import { FormRadio, ModalPreexistence } from '.';
import validate from '../helpers/dpsFormValidate';
import focusInputOnError from '../helpers/focusInputOnError';

interface IDpsFormProps {
  handleSubmit: () => void;
  previousPage: () => void;
}

export function DpsForm(props: IDpsFormProps) {
  const { handleSubmit, previousPage } = props;
  const [openModal, setOpenModal] = useState(false);
  const [dps, setDps] = useState(true);
  const toggleModal = (state: boolean) => (_: any) => setOpenModal(state);
  const changeDps = ({ target: { value } }: any) => setDps(JSON.parse(value));
  const submit = () => (dps ? handleSubmit() : setOpenModal(true));

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvDPS',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  }, []);

  return (
    <div className="col-12 col-md-10 wizard-card">
      <form noValidate={true}>
        <div className="row">
          <div className="col-12">
            <h2 className="wizard-card--title">
              Declaración personal de salud (DPS)
            </h2>
          </div>
          <div className="col-12">
            <div className="col-12 bg-near-white pt30 pb30 box-dps o-scroll">
              <p>
                ¿Usted alguna vez ha sido tratado, le han indicado que padece o
                tiene cualquier indicación conocida de alguna de estas
                enfermedades, dolencias o situaciones de salud?:
              </p>
              <ul>
                <li>Cirrosis Hepática y/o Biliar</li>
                <li>Diabetes Mellitus</li>
                <li>Insuficiencia Renal Crónica</li>
                <li>Lupus Eritematoso Sistémico</li>
                <li>IMC mayor a 40</li>
                <li>Trasplante de Órganos</li>
                <li>Hipertensión Arterial</li>
                <li>Cáncer</li>
                <li>Infarto</li>
                <li>Covid-19</li>
              </ul>
              <p>
                Teniendo en consideración lo declarado por usted, la compañía
                aseguradora acepta los riesgos propuestos , excluyendo de todas
                las coberturas del seguro la(s) enfermedades situación (es)
                preexistentes arriba indicadas y sus consecuencias.
              </p>
              <p>
                Aceptación: Otorgo mi consentimiento a que si la causa de un
                siniestro que me afecte fuera producto, derive o estuviese
                relacionada con algunas de las situaciones de salud o enfermedad
                antes indicadas, se consideren ellas como situaciones de salud o
                enfermedad diagnosticadas o conocidas antes de la contratación
                de este seguro, con la correspondiente exclusión de cobertura.
              </p>
              <p>
                Asimismo, entiendo y concuerdo que cualquier reticencia o
                declaración falsa o errónea de mi parte, faculta a la compañía
                aseguradora para rechazar el pago de la indemnización reclamada
                o poner término anticipado a todas las coberturas, formando esta
                declaración parte integrante de las condiciones del seguro
                contratado.
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-10 col-md-9 col-lg-7 col-xl-6 mx-auto mt30">
            <Field
              name="dpsDeclaration"
              options={[
                {
                  id: 'cleanDPS',
                  text: 'Usted está declarando no tener ninguna Preexistencia',
                  value: 'true',
                },
                {
                  id: 'dirtyDPS',
                  text: 'Poseeo una Preexistencia',
                  value: 'false',
                },
              ]}
              component={FormRadio}
              onChange={changeDps}
            />
          </div>
        </div>
        <div className="row justify-content-center mt30 buttons-container">
          <div className="col-12 col-sm-5 col-md-4">
            <button
              className="btn white back-to-charges"
              type="button"
              onClick={previousPage}
            >
              Volver
            </button>
          </div>
          <div className="col-12 col-sm-5 col-md-4">
            <button
              className="btn primary go-to-payment"
              type="button"
              onClick={submit}
            >
              Continuar
            </button>
          </div>
        </div>
      </form>
      <ModalPreexistence open={openModal} toggle={toggleModal} />
    </div>
  );
}

export default reduxForm<any, any>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: 'proposal',
  onSubmitFail: focusInputOnError,
  validate,
})(DpsForm);
